import { useUpdateServiceBooking } from "@/hooks/api-hooks";
import { Loader, Select } from "@mantine/core";
import { useTranslation } from "react-i18next";
import { Business, ServiceBooking } from "@turizi/shared";

interface ProviderSelectorProps {
    booking: ServiceBooking;
    size?: 'xs' | 'sm' | 'md' | 'lg';
    editable?: boolean;
}

export default function ProviderSelector({
    booking,
    size = 'sm',
    editable = true
}: ProviderSelectorProps) {
    const { t } = useTranslation();
    const { mutate: updateMutation, isPending: saving } = useUpdateServiceBooking();
    const service = booking?.service_data;

    const save = (selectedProviderId: number | null) => {
        if (!booking?.id) return;
        updateMutation({
            id: booking.id,
            selected_provider_id: selectedProviderId,
        });
    };

    if (!booking || !service) {
        return null;
    }

    const providers = service.providers || [];

    if (providers.length === 0) {
        return <div className="italic text-gray-400 text-xs">{t('no_providers')}</div>
    }

    if (!editable) {
        return (
            <div className="font-bold text-gray-600 bg-gray-50 rounded-md px-2 py-1 border border-gray-100 text-xxs">
                {providers.find(p => p.id === booking.selected_provider_id)?.name || t('no_provider_selected')}
            </div>
        )
    }

    return (
        <div>
            <Select
                variant="filled"
                searchable
                size={size}
                placeholder={t('no_provider_selected')}
                value={booking.selected_provider_id?.toString()}
                data={providers.map((provider: Business) => ({
                    value: provider.id.toString(),
                    label: provider.name
                }))}
                onChange={(value) => save(value ? Number(value) : null)}
                disabled={saving}
                rightSection={saving ? <Loader size="xs" color="black" /> : null}
                comboboxProps={{ keepMounted: false }}
            />
        </div>
    );
}
